import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mb-1"
}
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = ["aria-label", "onClick"]
const _hoisted_4 = { class: "border p-1 mb-2" }
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = { class: "list-group-flush p-0" }
const _hoisted_7 = ["aria-label", "onClick"]
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = { class: "input-group col" }
const _hoisted_10 = ["onUpdate:modelValue", "onChange"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "input-group col" }
const _hoisted_13 = ["onUpdate:modelValue", "disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["onClick", "disabled"]
const _hoisted_16 = {
  key: 1,
  class: "text-center text-muted mb-2 or-divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagSets, (draft, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `${_ctx.keyPrefix}${index}`
      }, [
        (_ctx.tagSets.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("small", _hoisted_2, "Condition " + _toDisplayString(index + 1), 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-danger",
                type: "button",
                "aria-label": _ctx.conditionAriaLabel(index),
                onClick: ($event: any) => (_ctx.removeTagSet(index))
              }, [
                _createVNode(_component_vue_feather, {
                  type: "x",
                  size: "14"
                }),
                _cache[1] || (_cache[1] = _createTextVNode(" Remove ", -1))
              ], 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(draft.tags), (tag) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "list-group-item d-flex justify-content-between align-items-center p-1",
                  key: tag[0]
                }, [
                  _createTextVNode(_toDisplayString(tag[0]) + ": " + _toDisplayString(tag[1]) + " ", 1),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-danger",
                    type: "button",
                    "aria-label": _ctx.tagAriaLabel(tag[0]),
                    onClick: ($event: any) => (_ctx.removeTag(draft, tag[0]))
                  }, [
                    _createVNode(_component_vue_feather, { type: "trash" })
                  ], 8, _hoisted_7)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "input-group-text" }, "Tag", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": ($event: any) => ((draft.selectTag) = $event),
                onChange: ($event: any) => (draft.selectTagValue = '')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTagOptionsForSet(draft), (tag) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: tag,
                    value: tag
                  }, _toDisplayString(tag), 9, _hoisted_11))
                }), 128))
              ], 40, _hoisted_10), [
                [_vModelSelect, draft.selectTag]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "input-group-text" }, "Value", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": ($event: any) => ((draft.selectTagValue) = $event),
                disabled: draft.selectTag === '' ? true : false
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensorTagOptions[draft.selectTag], (tagValue) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: tagValue,
                    value: tagValue
                  }, _toDisplayString(tagValue), 9, _hoisted_14))
                }), 128))
              ], 8, _hoisted_13), [
                [_vModelSelect, draft.selectTagValue]
              ]),
              _createElementVNode("button", {
                class: "btn btn-outline-success",
                type: "button",
                onClick: ($event: any) => (_ctx.addRuleTag(draft)),
                disabled: draft.selectTagValue === '' ? true : false
              }, [
                _createVNode(_component_vue_feather, { type: "plus" })
              ], 8, _hoisted_15)
            ])
          ])
        ]),
        (index < _ctx.tagSets.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, " — OR — "))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("button", {
      class: "btn btn-sm btn-outline-secondary mb-1",
      type: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addTagSet && _ctx.addTagSet(...args)))
    }, [
      _createVNode(_component_vue_feather, {
        type: "plus",
        size: "14"
      }),
      _cache[4] || (_cache[4] = _createTextVNode(" Add OR condition ", -1))
    ])
  ]))
}